var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBesttutor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 126 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#cb8b65;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 62.69,
    y1: 127.24,
    x2: 62.69,
    y2: 2.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed9765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 62.69,
    cy: 63.36,
    r: 62.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.69,
    cy: 63.36,
    r: 54.71
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 62.69,
    cy: 63.36,
    r: 42.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.19,75.05l5.1-2.67,3.17-1.67a3.22,3.22,0,0,1,2.29-.35.65.65,0,0,0,.83-.36q4.58-7.15,9.18-14.31a1.91,1.91,0,0,1,2.09-1A1.86,1.86,0,0,1,76,57.59c-1.31,2.07-2.65,4.12-4,6.18q-3,4.65-6,9.29a1.8,1.8,0,0,0-.31,1,3.35,3.35,0,0,1-1.85,3c-3.37,1.82-6.76,3.61-10.14,5.41a1.73,1.73,0,0,1-.7.27c-.79.06-.84.53-.82,1.18,0,1.42,0,2.85,0,4.28,0,.37-.07.5-.47.5q-7,0-13.91,0c-.38,0-.47-.11-.47-.48,0-4.79,0-9.58,0-14.37a7.41,7.41,0,0,1,14.7-1.35A12.69,12.69,0,0,1,52.19,75.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67,37.35H81.72a6.73,6.73,0,0,1,6.85,5.75,8.41,8.41,0,0,1,.08,1.33V58.69a6.79,6.79,0,0,1-7.11,7.09c-.71,0-1.43,0-2.14,0a1.85,1.85,0,1,1,0-3.7c.83,0,1.66,0,2.49,0a3,3,0,0,0,3-3q0-7.5,0-15a3,3,0,0,0-3.12-3c-3,0-6.06,0-9.09,0-6.71,0-13.41,0-20.11,0a3.27,3.27,0,0,0-3.53,3.56c.07,1,0,2.08,0,3.13a1.86,1.86,0,0,1-1.83,2,1.84,1.84,0,0,1-1.87-2,36.53,36.53,0,0,1,.1-4.68,6.71,6.71,0,0,1,6.27-5.66c2.47-.07,5,0,7.42,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.06,47.24h9.62a1.87,1.87,0,1,1,0,3.71H57.36a1.87,1.87,0,1,1,0-3.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.7,59a4.94,4.94,0,1,1-5-4.91A4.94,4.94,0,0,1,49.7,59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62,58.36H57.28a1.86,1.86,0,1,1,0-3.7h9.55a1.86,1.86,0,1,1,0,3.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBesttutor);
export default __webpack_public_path__ + "static/media/Best tutor.9859a43aa21ac562cd866aa2feb8fd01.svg";
export { ForwardRef as ReactComponent };